<template>
    <v-container>
      <h1>{{ t("agentList.directList") }}</h1>
      <v-data-table
        :headers="headers"
        :items="paginatedReferrals"
        :items-per-page="itemsPerPage"
        :server-items-length="referrals.length"
        :loading="loading"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>{{ t("agentList.directAddress") }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-pagination
              v-model="currentPage"
              :length="pageCount"
              @input="fetchReferrals(userAddress)"
            ></v-pagination>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-container>
  </template>
  <script setup>
  import { ref, computed, onMounted, defineProps } from 'vue'
  import { useI18n } from 'vue-i18n'
  const { t, locale } = useI18n();
  const referrals = ref([]);
  const currentPage = ref(1);
  const itemsPerPage = ref(10);
  const headers = computed(() => {
    const language = locale.value;
    return [
        { title: t('agentList.address', {language}), value: 'address' },
    ];
  });
  const props = defineProps({
    walletConnect: {
      type: Object,
      required: true
    }
  });
  const pageCount = computed(() => {
    return Math.ceil(referrals.value.length / itemsPerPage.value);
  });
  const paginatedReferrals = computed(() => {
    const start = (currentPage.value - 1) * itemsPerPage.value;
    const end = start + itemsPerPage.value;
    return referrals.value.slice(start, end);
  });
  const fetchReferrals = async () => {
    let addres = await props.walletConnect.getDirectUser();
    let data = [];
    for (let i = 0; i < addres.length; i++) {
      data.push({address: addres[i]});
    }
    referrals.value = data;
    console.log(referrals.value, "referrals");
  };
  onMounted(() => {
    fetchReferrals();
  });
  </script>
  
  <style scoped>
  /* 添加样式 */
  </style>